import { setVideoData } from './state';
import { parsePlaceHolder } from './parse';

const getMediaId = (params) => params.get('id') || params.get('jwId');

const getConfigValues = (placeholder, index) => {
  const VIEWABLE = 'viewable';
  const params = parsePlaceHolder(placeholder);

  let floating =
    params.get('floating') && params.get('floating') !== 'default'
      ? {
          floating: {
            dismissible: true,
            mode: params.get('floating'),
          },
        }
      : {};

  const aspectratio = params.get('aspectratio') || '16:9';

  if (aspectratio === '9:16') {
    floating = {
      floating: {
        dismissible: true,
        mode: 'never',
      },
    };
  }
  const autostart = index === 0 ? { autostart: VIEWABLE } : { autostart: false };

  // Earlier used logic
  // const autostart =
  //   index === 0
  //     ? { autostart: VIEWABLE }
  //     : params.get("autostart") === DEFFAULT || params.get("autostart") === ""
  //     ? { autostart: DEFFAULT }
  //     : {
  //         autostart: params.get("autostart") === "true" ? VIEWABLE : false,
  //       };

  //If mute is not set or put to default state, mute the videos in article
  //If video is not auto start, it should be unmuted
  const shouldMute = (param) =>
    (param === 'default' || param === 'true' || param === '') && autostart.autostart === VIEWABLE ? true : false;

  const mute = {
    mute: shouldMute(params.get('mute')),
  };

  return {
    id: getMediaId(params),
    placeholder,
    youplayId: params.get('ypPartId'),
    playerID: params.get('playerID'),
    isTop: params.get('isTop') === 'true',
    enableFakeLiveMode: params.get('enableFakeLiveMode') === 'true',
    config: {
      aspectratio,
      enableMovingThumbnail: params.get('enableMovingThumbnail') === 'true',
      ...autostart,
      ...floating,
      ...mute,
    },
  };
};

export function getVideoConfig(content) {
  // Get the video elements and do operation
  const videoPlaceholders = [
    ...content.querySelectorAll('.jwplayer_video .jwplayer_video-placeholder'),
    ...content.querySelectorAll('.jwplayer_video .jwplayer_video-yp-placeholder'),
  ];

  const configData = [];
  const playerIDs = [];

  // eslint-disable-next-line no-prototype-builtins
  if (videoPlaceholders && videoPlaceholders.length) {
    for (let idx = 0; idx < videoPlaceholders.length; idx++) {
      const placeholder = videoPlaceholders[idx];
      const params = parsePlaceHolder(placeholder);
      const playerId = params.get('playerID');
      if (!playerIDs.includes(playerId)) {
        playerIDs.push(playerId);
      }

      //Get JW Video config
      configData.push(getConfigValues(placeholder, idx));
    }

    setVideoData({
      playerIDs,
      configData,
    });
  }
}
